import type { ReactNode } from "react";
import { TariiWord } from "../TariiWord";
import "./pitch.css";
import { PitchIcon, type PitchIconName } from "./PitchIcons";
import { PitchTile } from "./PitchTile";

export const LAYER_COPY = {
  people: [
    { icon: "planner", title: "Planner", note: "Requests and the roster" },
    { icon: "member", title: "Team members", note: "Own roster and requests" },
    { icon: "coordinator", title: "Coordinator", note: "The day's changes" },
    { icon: "management", title: "Management", note: "Read-only view" },
  ] as Array<{ icon: PitchIconName; title: string; note: string }>,
  layerName: (<TariiWord />) as ReactNode,
  layerNote: "Requests, leave, standby, fairness and the roster",
  links: [
    { text: "Files today", dashed: false },
    { text: "API: planned", dashed: true },
  ],
  system: "Your HR or time system",
  systemNote: "Records and payroll stay here",
};

export interface LayerDiagramProps {
  copy?: typeof LAYER_COPY;
  mark?: React.ReactNode;
}

/** `beside.html`: people row, the Tarii layer, links, the system below. */
export function LayerDiagram({ copy = LAYER_COPY, mark }: LayerDiagramProps) {
  return (
    <div className="pitch pitch-layers">
      <div className="pitch-grid pitch-grid-4">
        {copy.people.map((p) => (
          <PitchTile key={p.title} title={p.title} icon={<PitchIcon name={p.icon} size={48} />}>
            {p.note}
          </PitchTile>
        ))}
      </div>
      <div className="pitch-down">
        {copy.people.map((p) => (
          <span key={p.title} className="pitch-arrow" data-dir="down" />
        ))}
      </div>
      <div className="pitch-layer" data-tone="core">
        <div className="pitch-tile-head">
          {mark}
          <p className="pitch-big">{copy.layerName}</p>
        </div>
        <p className="pitch-text">{copy.layerNote}</p>
      </div>
      <div className="pitch-links">
        {copy.links.map((l) => (
          <p key={l.text} className="pitch-link" data-style={l.dashed ? "dashed" : "solid"}>
            <i />
            {l.text}
          </p>
        ))}
      </div>
      <div className="pitch-layer">
        <p className="pitch-title">{copy.system}</p>
        <p className="pitch-text">{copy.systemNote}</p>
      </div>
    </div>
  );
}
